const getImageGridClass = (count) => {
  if (count === 1) return 'flex justify-center';
  if (count === 3) return 'md:grid-cols-3';
  return 'md:grid-cols-2';
};

const InsectSection = ({ name, features, lifeCycle, whereFound, behavior, images, species, fishingTip }) => (
  <div className="mb-20">
    <div className="bg-[#1E2328] rounded-3xl shadow-xl overflow-hidden border border-white/10">
      <div className="bg-gradient-to-r from-cyan-600 to-cyan-700 px-8 py-6">
        <h2 className="text-3xl font-bold text-white">{name}</h2>
      </div>
      <div className="p-8">
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-[#151b21] rounded-xl p-6">
            <h3 className="font-bold text-white mb-3">Features:</h3>
            <p className="text-slate-400">{features}</p>
          </div>
          <div className="bg-[#151b21] rounded-xl p-6">
            <h3 className="font-bold text-white mb-3">Life Cycle:</h3>
            <p className="text-slate-400">{lifeCycle}</p>
          </div>
          <div className="bg-[#151b21] rounded-xl p-6">
            <h3 className="font-bold text-white mb-3">Where Found:</h3>
            <p className="text-slate-400">{whereFound}</p>
          </div>
        </div>

        <div className="bg-[#137dc5]/10 rounded-xl p-6 mb-8">
          <h3 className="font-bold text-white mb-3">Behavior:</h3>
          <p className="text-slate-300">{behavior}</p>
        </div>

        <div className={`grid gap-6 mb-8 ${getImageGridClass(images.length)}`}>
          {images.map((img) => (
            <div key={img.alt} className={`bg-[#1E2328] rounded-2xl overflow-hidden shadow-md ${images.length === 1 ? 'max-w-lg w-full' : ''}`}>
              <img src={img.src} alt={img.alt} className="w-full h-auto object-cover" />
              <div className="p-4 bg-[#1E2328]">
                <p className="text-slate-300 font-semibold text-center">{img.caption}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-white mb-4">Common North American Species:</h3>
          <div className="grid md:grid-cols-2 gap-3">
            {species.map((s) => (
              <div key={s} className="flex items-center gap-2">
                <div className="w-2 h-2 bg-cyan-600 rounded-full"></div>
                <span className="text-slate-300">{s}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#137dc5]/15 to-[#137dc5]/5 rounded-xl p-6">
          <h3 className="font-bold text-[#3aa0e0] mb-2">Fishing Tip:</h3>
          <p className="text-slate-300">{fishingTip}</p>
        </div>
      </div>
    </div>
  </div>
);

export default InsectSection;
